import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from 'moment';
import 'moment/locale/ko';
import _ from 'lodash';
import { AiOutlineLeftCircle, AiOutlineRightCircle } from 'react-icons/ai';
import Button from '../../Button';
import styled from 'styled-components';
import { CustomCalendar } from '../../../pages/program/holiday';
import PrevBtn from '../../../../public/images/btn_pre2.svg';
import NextBtn from '../../../../public/images/btn_next2.svg';

const Block = styled.div`
  .arrow > * {
    font-size: 24px;
  }

  .date {
    font-size: 18px;
  }
`;

interface IProps {
  setTab: (tab: string) => void;
  setIsExtended: (isExtended: boolean) => void;
}

moment.locale('ko');
const localizer = momentLocalizer(moment);

const ClassCalendar: FC<IProps> = ({ setTab, setIsExtended }) => {
  const { t, i18n } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { timetables } = useSelector((state: RootState) => state.classTimetable);

  const [events, setEvents] = useState([]);
  const [year, setYear] = useState<number>(0);
  const [month, setMonth] = useState<number>(0);
  const [day, setDay] = useState<number>(0);
  const [date, setDate] = useState<any>();
  

  useEffect(() => {
    if (serverDate) {
      const _date = moment(serverDate);
      setDate(_date);

      const _year = sessionStorage.getItem('year');
      const _month = sessionStorage.getItem('month');
      if (_year && _month) {
        sessionStorage.removeItem('year');
        sessionStorage.removeItem('month');
        setYear(Number(_year));
        setMonth(Number(_month));  
        setDay(1);
      } else {
        setYear(Number(_date.format('YYYY')));
        setMonth(Number(_date.format('M')) - 1);
        setDay(Number(_date.format('D')));  
      }
    }
  }, [serverDate]);

  useEffect(() => {
    if (timetables) {
      const _timetables = _.cloneDeep(timetables).sort((a: any, b: any) => a.srtDate < b.srtDate ? -1 : (a.srtDate > b.srtDate ? 1 : 0));
      const data: any = [];
      _timetables.forEach((item, index) => {
        const year = Number(item.srtDate.slice(0, 4));
        const month = Number(item.srtDate.slice(4, 6)) - 1;
        const day = Number(item.srtDate.slice(6));
        data.push({
          id: item.timetableCode,
          title: `${item.srtTime} ${item.classRoomName}`,
          allDay: true,
          start: new Date(year, month, day),
          end: new Date(year, month, day + 1),
          resource: {
            type: 'timetable',
            index
          }
        });
        data.push({
          id: item.timetableCode,
          title: t('class.class.column34'),
          allDay: true,
          start: new Date(year, month, day),
          end: new Date(year, month, day + 1),
          resource: {
            type: 'attendance',
            index
          }
        });
        data.push({
          id: item.timetableCode,
          title: t('class.class.column35'),
          allDay: true,
          start: new Date(year, month, day),
          end: new Date(year, month, day + 1),
          resource: {
            type: 'score',
            index
          }
        });
      });
      setEvents(data);
    }
  }, [timetables]);

  const onSetPrevMonth = () => {
    if (month === 0) {
      setYear(year - 1);
      setMonth(11);
    } else {
      setMonth(month - 1);
    }
    setDay(1);
  }

  const onSetNextMonth = () => {
    if (month === 11) {
      setYear(year + 1);
      setMonth(0);
    } else {
      setMonth(month + 1);
    }
    setDay(1);
  }

  const onOpenCalendarEvent = (e: any) => {
    sessionStorage.setItem('timetableCode', e.id);
    sessionStorage.setItem('eventIndex', e.resource.index);
    sessionStorage.setItem('year', String(year));
    sessionStorage.setItem('month', String(month));

    switch (e.resource.type) {
      case 'timetable':
        setTab('calendarDetail');
        break;
      case 'attendance':
        setTab('rollbook');
        break;
      case 'score':
        setTab('score');
        break;
    }
  }

  const setToday = () => {
    setYear(Number(date.format('YYYY')));
    setMonth(Number(date.format('M')) - 1);
    setDay(Number(date.format('D')));
  }

  return (
    <Block>
      <div className="comm-bx__between"> 
        <h3 className="sub-title">
          {chosenClass?.className}
        </h3>
      </div>
      <div className="mt-3 flex">
        <div className="col-2 pl-0">
          <Button
            className="btn-basic pink-line"
            onClick={setToday}
            text={t('program.holiday.button1')}
          />
        </div>
        <Block className="col-8 text-center">
          <h5 className="d-inline-flex align-items-center">
              <span className="arrow mr-3 pointer">
                <img src={PrevBtn} onClick={onSetPrevMonth} alt={'이전버튼'} />
              </span>
            <span className="date">
                {
                  i18n.language === 'ko'
                    ? `${year} · ${(month + 1).toString().length > 1 ? '' : 0}${month + 1}`
                    : `${month + 1}·${year}`
                }
              </span>
            <span className="arrow ml-3 pointer">
                <img src={NextBtn} onClick={onSetNextMonth} alt={'다음버튼'} />
            </span>
          </h5>
        </Block>
        <div className="col-2" />
      </div>
      <div>
        <CustomCalendar
          localizer={localizer}
          culture={i18n.language === 'ko' ? 'ko-KR' : 'en-US'}
          events={events}
          date={new Date(year, month, day)}
          onSelectEvent={e => onOpenCalendarEvent(e)}
          selectable
          toolbar={false}
          style={{ minHeight: '900px', margin: '10px 0' }}
          // @ts-ignore
          dayPropGetter={date => {
            if (date.getDay() === 0 || date.getDay() === 6) {
              return { style: { background: '#fbfbfc' } }
            }
          }}
          // @ts-ignore
          eventPropGetter={(event: any) => {
            switch (event.resource.type) {
              case 'timetable':
                return { style: { background: '#f1a645' } }
              default:
                return { style: { background: '#65c1c1' } }
            }
          }}
          showAllEvents={true}
        />
      </div>
    </Block>
  );
}

export default ClassCalendar;
